@if (formField?.invalid && formField?.touched) {
<div
  role="alert"
  id="alertID"
  class="fdx-c-form-group__message fdx-c-form-group__message--has-message">
  <div class="fdx-c-form-message__icon" style="margin-right: 5px">
    <svg
      class="fdx-c-icon"
      aria-hidden="true"
      focusable="false"
      role="presentation">
      <use xlink:href="#utility_cross-fat"></use>
    </svg>
  </div>
  @if (formField?.errors?.['not_found']) {
  <span>Nie znaleziono przesyłki o podanym numerze.</span>
  } @if (formField?.errors?.['PARCEL_ALREADY_SENT']) {
  <span
    >List o podanym numerze został już nadany. Wprowadź Prawidłowy numer
    listu.</span
  >
  } @if (formField?.errors?.['LABEL_ALREADY_USED']) {
  <span>Zlecenie dla podanego numeru paczki już istnieje.</span>
  } @if (formField?.errors?.['RETURN_LABEL_EXPIRED']) {
  <span
    >Termin ważności etykiety upłynął
    {{formField?.errors?.['RETURN_LABEL_EXPIRED'].expiryDate}}</span
  >
  } @if (formField?.errors?.['required']) {
  <span>Pole wymagane.</span>
  } @if (formField?.errors?.['pattern']) {
  <span>Niewłaściwy format.</span>
  } @if (formField?.errors?.['min']) {
  <span>Wartość mniejsza od wartości mininalnej.</span>
  } @if (formField?.errors?.['max']) {
  <span>Przekroczona maksymalna wartość.</span>
  } @if (formField?.errors?.['min_parcel_count']) {
  <span>Liczba paczek musi być większa od 0.</span>
  } @if (formField?.errors?.['min_parcel_weight']) {
  <span>Łączna waga paczek musi być większa od 0.</span>
  } @if (formField?.errors?.['min_parcel_length']) {
  <span>Długość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['min_parcel_width']) {
  <span>Szerokość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['min_parcel_height']) {
  <span>Wysokość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['max_parcel_weight']) {
  <span>Przekroczona maksymalna waga: 70kg.</span>
  } @if (formField?.errors?.['max_parcel_length']) {
  <span>Przekroczona maksymalna długośc: 200cm.</span>
  } @if (formField?.errors?.['max_parcel_width']) {
  <span>Przekroczona maksymalna szerokość: 200cm.</span>
  } @if (formField?.errors?.['max_parcel_height']) {
  <span>Przekroczona maksymalna wysokość: 200cm.</span>
  } @if (formField?.errors?.['sum_of_parcel_dimensions_exceeded']) {
  <span>Suma wszystkich boków nie może być większa niż 300cm.</span>
  } @if (formField?.errors?.['sum_of_palette_dimensions_exceeded']) {
  <span>Suma wszystkich boków nie może być większa niż 420cm.</span>
  } @if (formField?.errors?.['min_palette_count']) {
  <span>Liczba palet musi być większa od 0.</span>
  } @if (formField?.errors?.['min_palette_weight']) {
  <span>Minimalna waga palety to 70kg.</span>
  } @if (formField?.errors?.['min_palette_length']) {
  <span>Długość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['min_palette_width']) {
  <span>Szerokość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['min_palette_height']) {
  <span>Wysokość nie może wynosić 0cm.</span>
  } @if (formField?.errors?.['max_palette_weight']) {
  <span>Przekroczona maksymalna waga: 800kg.</span>
  } @if (formField?.errors?.['max_palette_length']) {
  <span>Przekroczona maksymalna długośc: 140cm.</span>
  } @if (formField?.errors?.['max_palette_width']) {
  <span>Przekroczona maksymalna szerokość: 100cm.</span>
  } @if (formField?.errors?.['max_palette_height']) {
  <span>Przekroczona maksymalna wysokość: 180cm.</span>
  } @if (formField?.errors?.['max_cod_amount']) {
  <span>Maksymalna kwota pobrania wynosi 10 000 zł.</span>
  } @if (formField?.errors?.['max_inc_amount']) {
  <span>Maksymalna kwota ubezpieczenia wynosi 50 000 zł.</span>
  } @if (formField?.errors?.['min_cod_amount']) {
  <span>Kwota nie może być mniejsza od 0.</span>
  } @if (formField?.errors?.['min_inc_amount']) {
  <span>Kwota nie może być mniejsza od 0.</span>
  } @if (formField?.errors?.['inc_amount_lower_than_cod_amount']) {
  <span>Kwota ubezpieczenia powinna być równa kwocie pobrania lub wyższa.</span>
  } @if (formField?.errors?.['min_length_account_number']) {
  <span>Minimalna długość numeru konta to 26 znaków.</span>
  } @if (formField?.errors?.['max_length_account_number']) {
  <span>Maksymalna długość numeru konta to 26 znaków.</span>
  } @if (formField?.errors?.['iban_incorrect']) {
  <span>Podany numer konta bankowego jest nieprawidłowy.</span>
  } @if (formField?.errors?.['min_parcel_content_length']) {
  <span>Opis zawartości jest wymagany.</span>
  } @if (formField?.errors?.['invalid']) {
  <span>Niepoprawna wartość.</span>
  } @if (formField?.errors?.['invalid_email']) {
  <span>Niewłasciwy format maila.</span>
  } @if (formField?.errors?.['invalid_mobile_phone_number']) {
  <span>Niepoprawny numer komórkowy.</span>
  } @if (formField?.errors?.['invalid_phone_number']) {
  <span>Niepoprawny numer telefonu.</span>
  } @if (formField?.errors?.['past_date']) {
  <span>Data nie może być wcześniejsza niż dzisiejsza.</span>
  } @if (formField?.errors?.['max_future_date']) {
  <span>Data nie może wybiegać ponad 14 dni.</span>
  } @if (formField?.errors?.['payerNo_not_found']) {
  <span>Nie znaleziono klienta krajowego FedEx o podanym numerze.</span>
  } @if (formField?.errors?.['payerNo_on_black_list']) {
  <span
    >Klient krajowy FedEx o podanym numerze znajduje się na czarnej
    liście.</span
  >
  } @if (formField?.errors?.['zip_code_city_inconsistent']) {
  <span>Kod pocztowy nie pasuje do podanego miasta.</span>
  } @if (formField?.errors?.['DATE_UNAVAILABLE']) {
  <span>Usługa niedostępna w wybranym dniu.</span>
  } @if (formField?.errors?.['VALUE_TOO_HIGH']) {
  <span>Przekroczono maksymalną wartość.</span>
  } @if (formField?.errors?.['VALUE_TOO_LOW']) {
  <span>Wartość mniejsza od wartości minimalnej.</span>
  } @if (formField?.errors?.['TOO_LONG']) {
  <span>Przekroczono dozwoloną długość.</span>
  } @if (formField?.errors?.['INCORRECT_FORMAT']) {
  <span>Niepoprawny format.</span>
  } @if (formField?.errors?.['INCONSISTENT']) {
  <span>Wartość niespójna z innymi elementami systemu.</span>
  } @if (formField?.errors?.['ENUM_ERROR']) {
  <span>Wartość spoza dozwolonych wartości.</span>
  } @if (formField?.errors?.['DATE_FROM_PAST']) {
  <span>Nieaktulana data.</span>
  } @if (formField?.errors?.['DATE_TOO_FAR_INTO_THE_FUTURE']) {
  <span>Data nie może wybiegać w przyszłość dalej niż _ dni</span>
  } @if (formField?.errors?.['COD_NOT_ALLOWED']) {
  <span>Punkt nie obsługuje pobrań.</span>
  } @if (formField?.errors?.['INS_VALUE_EXCEEDS_PUDO_MAX']) {
  <span>Kwota ubezpieczenia przekracza maksymalną dla punktu.</span>
  } @if (formField?.errors?.['COD_VALUE_EXCEEDS_PUDO_MAX']) {
  <span>Kwota pobrania przekracza maksymalną dla punktu.</span>
  } @if (formField?.errors?.['PUDO_MULTI_PARCEL']) {
  <span>Przesyłka do punktu powinna być jednoelementowa.</span>
  } @if (formField?.errors?.['PUDO_NOT_EXISTS']) {
  <span>Punkt nie istnieje.</span>
  } @if (formField?.errors?.['PUDO_NOT_ACTIVE']) {
  <span
    >Punkt jest aktualnie nieaktywny. Wybierz inny punkt lub spróbuj
    ponownie.</span
  >
  } @if (formField?.errors?.['PUDO_NON_STANDARD_PARCEL']) {
  <span>Paczka niestandardowa nie może być dostarczona do punktu.</span>
  }
</div>
}
